export const SummaryChartTypes = {
  IGetSummaryChartService: Symbol("IGetSummaryChartService"),
};
